// extracted by mini-css-extract-plugin
export default {"wrap":"Banner_wrap__XGxim","body":"Banner_body__KKAZt","head":"Banner_head__W5KKJ","title":"Banner_title__DVIn0","subtitle":"Banner_subtitle__ZNU-0","text":"Banner_text__iUx9X"};